import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTING } from 'app/common/routeConstants';
import { ClaimsTrackerLoadGuard, IncidentDetailsLoadGuard, PaymentOptionsLoadGuard, PropertyTrackerLoadGuard } from 'app/route_guards/claims-tracker.guard';

const DASHBOARD = ROUTING.DASHBOARD;
const AUTO = ROUTING.AUTO;
const CLAIMS = ROUTING.CLAIMS;
const PROPERTY = ROUTING.PROPERTY;
const ACH = ROUTING.ACH;
const UPLOAD = ROUTING.UPLOAD;
const ClaimsDashboardRoutes: Routes = [
    {
        path: `${DASHBOARD.BASE_PATH}`,
        children: [
            {
                path: `${DASHBOARD.CHILD_PATH_INCIDENT}`,
                loadChildren: (): any =>
                    import('./incident-details/incident-details.module').then(
                        (m) => m.IncidentDetailsModule
                    ),
                canLoad: [IncidentDetailsLoadGuard]
            },
            {
                path: `${DASHBOARD.CHILD_PATH_TRACKER}`,
                loadChildren: (): any =>
                    import('./old-tracker/claim-tracker.module').then(
                        (m) => m.ClaimTrackerModule
                    ),
                canLoad: [ClaimsTrackerLoadGuard]

            },
            {
                path: `${DASHBOARD.CHILD_PATH_MFA}`,
                loadChildren: (): any => import('./mfa/mfa.module').then((m) => m.MfaModule)
            }
        ]
    },
    {
        path: `${ACH.BASE_PATH}`,
        children: [
            {
                path: `${ACH.CHILD_PATH}`,
                loadChildren: (): any =>
                    import('./claimspayment/claims-payment.module').then(
                        (m) => m.ClaimsPaymentModule
                    ),
                canLoad: [PaymentOptionsLoadGuard]
            }
        ]
    },
    {
        path: `${UPLOAD.BASE_PATH}`,
        children: [
            {
                path: ``,
                loadChildren: (): any =>
                    import('./file-upload/file-upload.module').then(
                        (m) => m.FileUploadModule
                    )
            }
        ]
    },
    {
        path: `${AUTO.BASE_PATH}`,
        children: [
            {
                path: `${AUTO.CHILD_PATH_TRACKER}`,
                loadChildren: (): any =>
                    import('./claim-tracker-auto/claim-tracker-auto.module').then(
                        (m) => m.ClaimTrackerAutoModule
                    ),
                canLoad: [ClaimsTrackerLoadGuard]
            }
        ]
    },
    {
        path: `${CLAIMS.BASE_PATH}`,
        children: [
            {
                path: `${CLAIMS.CHILD_PATH_TRACKER}`,
                    loadChildren: (): any =>
                    import('./express-login/express-login.module').then(
                        (m) => m.ExpressLoginModule
                    )
            }
        ]
    },
    {
        path: `${PROPERTY.BASE_PATH}`,
        children: [
            {
                path: `${PROPERTY.CHILD_PATH_TRACKER}`,
                loadChildren: (): any =>
                    import('./claim-tracker-property/claim-tracker-property.module').then(
                        (m) => m.ClaimTrackerPropertyModule
                    ),
                canLoad: [PropertyTrackerLoadGuard]
            }
        ]
    }
];
@NgModule({ schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [],
    exports: [RouterModule], imports: [RouterModule.forChild(ClaimsDashboardRoutes)], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ClaimsDashboardModule { }
